import useInitialData from '@page-components/Layout/useInitialData'

interface UseWebsiteInfoReturns {
  websiteId?: string
  websiteName?: string
  websiteDescription?: string
  websiteCountryCode?: string
  websiteCanSendDevolutionDataEmail?: boolean
  websiteCategories?: string[]
  websiteTimezone?: string
  websiteLocale?: string
  websiteBaseURL?: string
  websiteLoginWithExternalProvidersAvailable?: string
}

// returns only the most general website information
export default function useWebsiteInfo(): UseWebsiteInfoReturns {
  const initialData = useInitialData()

  const website = initialData?.website

  if (!website) return {}

  return {
    websiteId: website._id,
    websiteName: website.name,
    websiteDescription: website.description,
    websiteCountryCode: website.countryCode,
    websiteCanSendDevolutionDataEmail: website.country.canSendDevolutionDataEmail,
    websiteLocale: website.country.locale,
    websiteBaseURL: website.baseURL,
  }
}
